import { atom, useAtom } from 'jotai';
import { TurnaroundOriginForm } from '../models';

const turnaroundOriginForm = atom<TurnaroundOriginForm>({
  // NOTE: supplier is shared between origin and destination forms
  orderNumber: '',
  surgeryReference: '',
  deliveryNumber: '',
  surgeon: null,
  surgeryDate: undefined,
});

export const useTurnaroundOriginForm = () => useAtom(turnaroundOriginForm);
